import React from "react";
import { Box, TextField, InputAdornment, Typography } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./InputWithLabel.module.css";

const InputWithLabel = ({ label, placeholder, icon: Icon, onChange, inputRef, defaultValue }) => {
  return (
    <Box className={styles.inputContainer}>
      <Typography className={styles.inputLabel}>{label}</Typography>
      <TextField
        placeholder={placeholder}
        variant="outlined"
        className={styles.inputField}
        defaultValue={defaultValue}
        onChange={(e) => onChange(e.target.value)}
        inputRef={inputRef} // Attach ref here
        InputProps={{
          endAdornment: Icon ? (
            <InputAdornment position="end">
              <Icon size={20} />
            </InputAdornment>
          ) : null,
          style: { borderRadius: "50px" },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "50px",
            width: "280px",
          },
          "& .MuiInputBase-input": {
            padding: "10px 16px",
          },
        }}
      />
    </Box>
  );
};

InputWithLabel.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  onChange: PropTypes.func.isRequired,
  inputRef: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ])
};

export default InputWithLabel;